module.exports = __webpack_public_path__ + "static/media/view talent sub-category.f5befe71.svg";